/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import { SvgIcon, Heading } from 'seduo-ui';
import { path } from '../basename';
const UINav = ({ navItems }) => {
    return (<nav className="header__nav">
            <div className="header__block-left">
                <Link className="header__logo" to={path()} title="Seduo.cz">
                    <SvgIcon kind="Logo" height={26} width={101}/>
                </Link>
                <div className="header__categories-wrapper">
                    <div className="dropdown dropdown--header">
                        <button id="headerMenu" className="btn header__button" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-offset="-15,30">
                            <SvgIcon kind="Categories" className="header__icon"/>
                            <span className="mx-5">Navigation</span>
                        </button>
                        <div className="dropdown-menu dropdown-menu--header" aria-labelledby="headerMenu" data-placement="bottom-start">
                            <ul className="header__menu-list">
                                <li className="header__menu-item">
                                    <Heading level={6} className="header__menu-header">
                                        <strong>Navigation</strong>
                                    </Heading>
                                </li>
                                {navItems.map(({ to, name, icon }, index) => (<li key={`dropdown_category_${index}`} className="header__menu-item">
                                        <Link className="header__menu-link" to={path(to)}>
                                            <SvgIcon kind={icon} className="header__icon header__menu-icon"/> {name}
                                        </Link>
                                    </li>))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <ul className="header__navigation">
                <li className="header__navigation-item header__navigation-item--visible-md">
                    <a className="header__navigation-link" href="https://www.seduo.cz">
                        Seduo.cz
                    </a>
                </li>
                <li className="header__navigation-item header__navigation-item--hidden-md">
                    <button className="header__navigation-button header__button btn" type="button" data-toggle="collapse" data-target="#header-menu" aria-controls="header-menu" aria-expanded="false" aria-label="Toggle navigation">
                        <div className="icon-menu">
                            <span className="icon-menu__line"/>
                            <span className="icon-menu__line"/>
                            <span className="icon-menu__line"/>
                        </div>
                    </button>
                </li>
            </ul>
        </nav>);
};
UINav.propTypes = {
    navItems: PropTypes.array.isRequired,
};
export default UINav;
